import React from 'react'
import './about.css'
import ME from '../../assests/me1.jpg'
import {FaAward} from 'react-icons/fa'
import {FiUsers} from 'react-icons/fi'
import {AiOutlineFundProjectionScreen} from 'react-icons/ai'

const About = () => {
  return (
    <section id='about'>
      <h5>Get To know</h5>
      <h2>About Me</h2>

      <div className="container about__container">
        <div className="about__me">
          <div className="about__me-image">
            <img src={ME} alt="AboutImage" />
          </div>
        </div>

        <div className="about__content">
          <div className="about__cards">
            <article className="about__card">
              <FaAward className="about__icon"/>
              <h5>Experience</h5>
              <small>3+ Years</small>
            </article>
            <article className="about__card">
              <FiUsers className="about__icon"/>
              <h5>Clients</h5>
              <small>70+</small>
            </article>
            <article className="about__card">
              <AiOutlineFundProjectionScreen className="about__icon"/>
              <h5>International Projects</h5>
              <small>50+ Completed</small>
            </article>
          </div>
          <p className='para'>
            I’m a gold medalist and an 8-time Rector Award recipient for academic excellence, maintaining a 4.0 GPA each semester. I’ve also won a filmmaking competition competing against 50 colleges, experiences that toned both my creative vision and technical skills.
          </p>
           <p className='para'>
            As a cinematographer, photographer, and media graduate, I serve as Creative Head at PictroIzzah and founder of FilmsbyAhmad, working across weddings, fashion, and commercial projects to turn real moments into cinematic stories.
           </p>
           <p className='para'>
            I’m constantly exploring new ideas at the intersection of creativity, business, and storytelling. When I’m not behind the camera, you’ll find me reading, writing, or learning something new. For me, visuals are more than aesthetics, they capture emotion, detail, and purpose. Every frame should feel honest, and every story should resonate on a human level.
           </p>
           <p className='para'>
           Let’s create something meaningful together.
           </p>
           <a href="#contact" className='btn btn-primary'>Connect With Me</a>
        </div>
      </div>
    </section>
  )
}

export default About